import { PublicClientApplication, EventType, InteractionRequiredAuthError } from "@azure/msal-browser";

const TENANT_ID = "e2458d43-9af5-4562-86b3-2056da5b537e";
const SPA_APP_CLIENT_ID = "859253f3-8ada-49c5-ab38-9247a5ec0bf2";
const API_APP_CLIENT_ID = "8a1940e4-bdd9-420d-af2a-19f1d8f6e13d";

export const API_SCOPES = [`api://${API_APP_CLIENT_ID}/access_as_user`];

export const msal = new PublicClientApplication({
  auth: {
    clientId: SPA_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: process.env.VUE_APP_POSTLOGINURL,
    postLogoutRedirectUri: process.env.VUE_APP_POSTLOGINURL,
    navigateToLoginRequestUrl: false,
  },
  cache: { cacheLocation: "localStorage", storeAuthStateInCookie: false },
  system: { allowNativeBroker: false },
});

export async function initMsal() {
  await msal.initialize();
  const result = await msal.handleRedirectPromise();
  if (result && result.account){
    msal.setActiveAccount(result.account);
  }
  const existing = msal.getActiveAccount() || msal.getAllAccounts()[0] || null;
  if (existing) msal.setActiveAccount(existing);

  msal.addEventCallback((e) => {
    if (e.eventType === EventType.LOGIN_SUCCESS && e.payload && e.payload.account) {
      msal.setActiveAccount(e.payload.account);
    }
  });
}

export async function ensureLoggedIn() {
  if (!msal.getActiveAccount()) {
    await msal.loginRedirect({ scopes: API_SCOPES });
  }
}

export async function getAccessToken() {
  const account = msal.getActiveAccount();
  if (!account) {
    return null;
  }

  try {
    const resp = await msal.acquireTokenSilent({ account, scopes: API_SCOPES });

    // console.log("acquireTokenSilient");
    // console.log(resp);

    return resp.accessToken;
  } catch (e) {

    if (e instanceof InteractionRequiredAuthError) {
      // Token refresh failed — interactive login is required
      await msal.acquireTokenRedirect({ scopes: API_SCOPES });
      return null; // this will redirect, so no need to return a token now
    }

    if (e && (e.errorCode === "interaction_in_progress" || e.errorCode === "browser_authentication_in_progress")) {
      // Stale interaction lock — clear it and redirect to login
      sessionStorage.removeItem("interaction.status");
      await msal.acquireTokenRedirect({ scopes: API_SCOPES });
      return null;
    }

    console.error("MSAL: Failed to get access token silently", e);
    return null;
  }
}



export function Authenticated(){
  const accounts = msal.getAllAccounts();

    if (accounts.length > 0) {
        return true;
    } else {
        return false;
    }
  };